/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DurationService } from '@app/modules/core/services/duration/duration.service';

@Component({
    selector: 'topo-duration-select',
    templateUrl: './duration-select.component.html',
    styleUrls: ['./duration-select.component.scss'],
    standalone: false
})
export class DurationSelectComponent implements OnInit, OnDestroy {
  @Output() valueChanged = new EventEmitter<number>();
  @Input() set value(value: number) {
    this.numberValue = value;
    const details = this.durationService.getDurationDetailsFromValue(this.numberValue);
    this.dayValue = details.days;
    this.hourValue = details.hours;
    this.minuteValue = details.minutes;
    this.validateFieldValues();
  }
  @Input() maxDays: number = 365;
  @Input() maxHours: number = 23;
  @Input() maxMinutes: number = 59;

  numberValue: number;
  dayValue: number;
  hourValue: number;
  minuteValue: number;

  private validateFieldValues(): void {
    if (this.dayValue > this.maxDays) {
      this.dayValue = this.maxDays;
    }
    if (this.hourValue > this.maxHours) {
      this.hourValue = this.maxHours;
    }
    if (this.minuteValue > this.maxMinutes) {
      this.minuteValue = this.maxMinutes;
    }
  }

  constructor(private durationService: DurationService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  numberPresetChanged(elm: any): void {
    this.onValueChanged();
  }

  numberFieldChanged(elm: any): void {
    this.validateFieldValues();
    this.numberValue = this.durationService.getDurationFromDetails(this.dayValue, this.hourValue, this.minuteValue);
    this.onValueChanged();
  }

  onValueChanged(): void {
    this.valueChanged.emit(this.numberValue);
  }
}
